<section class="accounting-firm-introduce-wrapper">
  <div class="box-container">
    <div class="accounting-firm-topic">
      <!-- desktop and tablet heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--desktop color-white"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.MORE_INFORMATION.HEADING' | translate"
      >
      </div>
      <!-- mobile heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--mobile color-white"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.MORE_INFORMATION.HEADING_MOBILE' | translate"
      >
      </div>
    </div>

    <div class="box">
      <div class="box__btn">
        <a
          id="tracking-findaccountingfirm2"
          target="_blank"
          rel="nofollow"
          href="https://form.flowaccount.com/find-an-accountant"
          class="flowbtn box__btn--layout"
        >
          {{ 'NEW_ACCOUNTING_FIRM.MORE_INFORMATION.BUTTON' | translate }}</a
        >
      </div>
    </div>
  </div>
</section>
